function denominationShow(product, denominationContainer) {
    for (let i = 0; i < product.tags.length; i++) {
        if (product.tags.includes('plantes-pot')) {
            if (product.tags[i] == "Succulentes") {
                denominationContainer.html("<a href='/collections/plantes-succulentes' class='sizeContainer'>" + locales.succulent + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Plantes et palmiers") {
                denominationContainer.html("<a href='/collections/plantes-vertes-palmiers' class='sizeContainer'>" + locales.palms + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Euphorbes") {
                denominationContainer.html("<a href='/collections/plantes-euphorbes' class='sizeContainer'>" + locales.euphorbia + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Cactus") {
                denominationContainer.html("<a href='/collections/plantes-cactus' class='sizeContainer'>" + locales.cactus + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Sapin") {
                denominationContainer.html("<a href='/collections/plantes-sapin' class='sizeContainer'>" + locales.fir + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            }
        } else {
            if (product.tags[i] == "Succulentes") {
                denominationContainer.html("<a href='/collections/recharges-plantes-succulentes' class='sizeContainer'>" + locales.succulent + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Plantes et palmiers") {
                denominationContainer.html("<a href='/collections/recharges-plantes-vertes-palmiers' class='sizeContainer'>" + locales.palms + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Euphorbes") {
                denominationContainer.html("<a href='/collections/recharges-plantes-euphorbes' class='sizeContainer'>" + locales.euphorbia + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Cactus") {
                denominationContainer.html("<a href='/collections/recharges-plantes-cactus' class='sizeContainer'>" + locales.cactus + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            } else if (product.tags[i] == "Sapin") {
                denominationContainer.html("<a href='/collections/recharges-plantes-sapin' class='sizeContainer'>" + locales.fir + "</a>" + "&nbsp;" + "&mdash;" + "&nbsp;");
            }
        }
    }
}

function sizeChoice(product, sizeContainer) {
    if (product.tags.includes('plantes-pot')) {
        if (product.tags.includes('XXS')) {
            sizeContainer.html("<a href='/collections/plantes-miniatures' class='sizeContainer'>" + locales.mini + "&nbsp;" + "&nbsp;" + "⌀ 6cm</a>");
        } else if (product.tags.includes('XS')) {
            sizeContainer.html("<a href='/collections/plantes-petites' class='sizeContainer'>" + locales.small + "&nbsp;" + "&nbsp;" + "⌀ 8cm</a>");
        } else if (product.tags.includes('S')) {
            sizeContainer.html("<a href='/collections/plantes-standards' class='sizeContainer'>" + locales.standard + "&nbsp;" + "&nbsp;" + "⌀ 10cm</a>");
        } else if (product.tags.includes('M')) {
            sizeContainer.html("<a href='/collections/plantes-grandes' class='sizeContainer'>" + locales.tall + "&nbsp;" + "&nbsp;" + "⌀ 14cm</a>");
        } else if (product.tags.includes('L')) {
            sizeContainer.html("<a href='/collections/plantes-tres-grandes' class='sizeContainer'>" + locales.veryTall + "&nbsp;" + "&nbsp;" + "⌀ 18cm</a>");
        } else if (product.tags.includes('XL')) {
            sizeContainer.html("<a href='/collections/plantes-xl' class='sizeContainer'>" + locales.grand + "&nbsp;" + "&nbsp;" + "⌀ 24cm</a>");
        }
    } else {
        if (product.tags.includes('XXS')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-miniatures' class='sizeContainer'>" + locales.mini + "&nbsp;" + "&nbsp;" + "⌀ 6cm</a>");
        } else if (product.tags.includes('XS')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-petites' class='sizeContainer'>" + locales.small + "&nbsp;" + "&nbsp;" + "⌀ 8cm</a>");
        } else if (product.tags.includes('S')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-standards' class='sizeContainer'>" + locales.standard + "&nbsp;" + "&nbsp;" + "⌀ 10cm</a>");
        } else if (product.tags.includes('M')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-grandes' class='sizeContainer'>" + locales.tall + "&nbsp;" + "&nbsp;" + "⌀ 14cm</a>");
        } else if (product.tags.includes('L')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-tres-grandes' class='sizeContainer'>" + locales.veryTall + "&nbsp;" + "&nbsp;" + "⌀ 18cm</a>");
        } else if (product.tags.includes('XL')) {
            sizeContainer.html("<a href='/collections/recharges-plantes-xl' class='sizeContainer'>" + locales.grand + "&nbsp;" + "&nbsp;" + "⌀ 24cm</a>");
        }
    }

    if (product.tags.includes('bougies-pot')) {
        if (product.tags.includes('4 mèches')) {
            sizeContainer.html("<a href='/collections/bougies' class='sizeContainer'>4 " + locales.wicks + "&nbsp;—&nbsp;" + locales.tall + "&nbsp;&nbsp;" + "⌀ 14cm</a>");
        } else if (product.tags.includes('3 mèches')) {
            sizeContainer.html("<a href='/collections/bougies' class='sizeContainer'>3 " + locales.wicks + "&nbsp;—&nbsp;" + locales.standard + "&nbsp;&nbsp;" + "⌀ 10cm</a>");
        } else if (product.tags.includes('1 mèche')) {
            if (product.tags.includes('XXS')) {
                sizeContainer.html("<a href='/collections/bougies' class='sizeContainer'>1 " + locales.wick + "&nbsp;—&nbsp;" + locales.mini + "&nbsp;&nbsp;" + "⌀ 6cm</a>");
            } else {
                sizeContainer.html("<a href='/collections/bougies' class='sizeContainer'>1 " + locales.wick + "&nbsp;—&nbsp;" + locales.small + "&nbsp;&nbsp;" + "⌀ 8cm</a>");
            }
        }
    } else {
        if (product.tags.includes('4 mèches')) {
            sizeContainer.html("<a href='/collections/recharges-bougies' class='sizeContainer'>4 " + locales.wicks + "&nbsp;—&nbsp;" + locales.tall + "&nbsp;&nbsp;" + "⌀ 14cm</a>");
        } else if (product.tags.includes('3 mèches')) {
            sizeContainer.html("<a href='/collections/recharges-bougies' class='sizeContainer'>3 " + locales.wicks + "&nbsp;—&nbsp;" + locales.standard + "&nbsp;&nbsp;" + "⌀ 10cm</a>");
        } else if (product.tags.includes('1 mèche')) {
            if (product.tags.includes('XXS')) {
                sizeContainer.html("<a href='/collections/recharges-bougies' class='sizeContainer'>1 " + locales.wick + "&nbsp;—&nbsp;" + locales.mini + "&nbsp;&nbsp;" + "⌀ 6cm</a>");
            } else {
                sizeContainer.html("<a href='/collections/recharges-bougies' class='sizeContainer'>1 " + locales.wick + "&nbsp;—&nbsp;" + locales.small + "&nbsp;&nbsp;" + "⌀ 8cm</a>");
            }

        }
    }
}

function getSecondaryProductSize(ref) {
    size = -1;
    switch (ref) {
        case 'XXS1':
            size = 6;
            break;
        case 'XXS2':
            size = 4;
            break;
        case 'XS1':
            size = 8;
            break;
        case 'XS2':
            size = 6;
            break;
        case 'S1':
            size = 10;
            break;
        case 'S2':
            size = 8;
            break;
        case 'M1':
            size = 14;
            break;
        case 'M2':
            size = 12;
            break;
        case 'L1':
            size = 18;
            break;
        case 'L2':
            size = 16;
            break;
    }
    return size;
}

function sliceString(input, maxSize) {
    let currentLineSize = 0;
    let currentLineValue = "";
    for (let j = 0; j < input.length; j++) {
        currentLineSize += sizeOfLetter(input[j]);
        if (currentLineSize > maxSize) {
            break;
        }
        currentLineValue += input[j];
    }

    return currentLineValue;
}

function sizeOfLetter(letter) {
    let letters = '«»àô€ÀÈÊÉéèê !"#$%&\'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~–\n\r‘’£çëâ—ÛÜÆÄÂËÏÎÔÖ♡:heart::sparkling_heart::blue_heart::black_heart::heart::hearts:´';
    let pixel = [7, 7, 10, 10, 10, 12, 10, 10, 10, 10, 10, 10, 3, 5, 7, 11, 10, 14, 12, 3, 6, 6, 7, 9, 5, 6, 4, 8, 11, 6, 10, 10, 10, 10, 10, 9,
        11, 10, 4, 4, 7, 9, 7, 8, 14, 12, 10, 12, 12, 10, 8, 14, 12, 5, 6, 12, 8, 15, 13, 15, 10, 15, 11, 9, 8, 12, 11, 16, 12, 11, 11, 6, 5, 6,
        9, 9, 5, 10, 10, 9, 10, 10, 5, 10, 10, 4, 4, 9, 5, 15, 10, 10, 10, 10, 6, 9, 5, 10, 9, 13, 9, 9, 9, 6, 5, 6, 9, 9, 0, 0, 4, 4, 11, 9, 10,
        10, 18, 12, 12, 13, 12, 12, 10, 5, 5, 15, 15, 15, 16, 15, 15, 15, 15, 16, 4]
    let index = letters.indexOf(letter);
    let size = 16;

    if (index !== -1) {
        size = pixel[index];
    }

    return size;
}

function sizeOfSentence(sentence, emojis) {
    let total = 0;

    for (let i = 0; i < sentence.length; i++) {
        total = total + sizeOfLetter(sentence.charAt(i));

        if (emojis !== undefined && emojis.has(i)) {
            i = i + emojis.get(i).length - 1;
        }
    }

    return total;
}

function stripHtml(html) {
    var tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
}

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Handle Emoji
const imageHost = "https://gitlab.com",
    imagePath = "/by-charlot-public/emoji/-/raw/master/unicode/64/",
    imageExt = ".png",
    emojiPattern = /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g;

function searchEmoji(str) {
    let emojis = new Map();

    let match;
    while (match = emojiPattern.exec(str)) {
        const emoji = match[0];
        const arrayEmoji = [...emoji];
        const place = match.index;
        const length = arrayEmoji.length;

        let imageName = "";
        let first = true;
        let realSize = 0;
        for (let i = 0; i < length; i++) {
            let unicode = emojiUnicode(arrayEmoji[i]);

            if (unicode.length > 4) {
                realSize += 2;
            } else {
                realSize++;
            }

            if (unicode === "fe0f" || unicode === "200d") {
                continue;
            } else {
                if (!first) {
                    imageName += "-";
                }

                imageName += unicode;
                first = false;
            }
        }

        emojis.set(place, {value: emoji, place: place, length: realSize, img: imageName});
    }

    return emojis;
}

function replaceEmoji(str, emojis, className) {
    if (emojis.size > 0) {
        emojis.forEach(function (emoji, key, map) {
            let img = document.createElement('IMG');
            img.src = imageHost + imagePath + emoji.img + imageExt;
            img.alt = emoji.img;
            img.className = className;

            str = str.replace(emoji.value, img.outerHTML);
        });
    }

    return str;
}

function emojiUnicode(emoji) {
    let comp;
    if (emoji.length === 1) {
        comp = emoji.charCodeAt(0);
    } else {
        comp = (
            (emoji.charCodeAt(0) - 0xD800) * 0x400
            + (emoji.charCodeAt(1) - 0xDC00) + 0x10000
        );
    }
    if (comp < 0) {
        comp = emoji.charCodeAt(0);
    }

    let unicode = comp.toString("16");
    if (unicode.length < 4) {
        unicode = unicode.padStart(4, '0');
    }

    return unicode;
}

const defaultSpaceSize = 3,
    defaultSpaceValue = " ";

let Customizer = (function() {
  'use strict';

  function Customizer() {
    this.defaultTitle = '',
    this.defaultText = '',
    this.size = '',
    this.sku = '',
    this.title = '',
    this.text = '',
    this.html = '',
    this.key = null,
    this.count = 0,
    this.html = '',

    this.customTitle = '',
    this.customText = '',
    this.customTitleSize = '',
    this.customTopMargin = '',
    this.customUnderTitleMargin = '',
    this.customUnderSubTitleMargin = '',

    this.maxSubTitleLines = 3,
    this.titleLinesCount = 1,
    this.subTitleLinesCount = 1,
    this.maxShortTitleLineSize = -1,
    this.maxLongTitleLineSize = -1,
    this.maxSubTitleLineSize = -1;

    this.container;
    this.template;
    this.logoUrl;

    this.displayTitleInput = true;
    this.displaySubTitleInput = true;

    this.isOpenCustomizer = false;

    this.timeoutKeyUpTitle = null;
    this.timeoutKeyUpSubTitle = null;

    this.isTyping = false;
  };

    Customizer.prototype.init = function init(container, sku, size, title, text, template, logoUrl, computeOnLoad){
    this.size = size;
    this.sku = sku;
    this.defaultTitle = title;
    this.defaultText = text;
    this.container = container;
    this.template = template;
    this.logoUrl = logoUrl;

    this.updateTitle(title);
    this.updateText(text);

    switch (size.toLowerCase()) {
      case 'xxs':
        this.maxShortTitleLineSize = 120;
        this.maxLongTitleLineSize = 144;
        this.maxSubTitleLineSize = 216;
      break;
      case 'xs':
        this.maxShortTitleLineSize = 108;
        this.maxLongTitleLineSize = 132;
        this.maxSubTitleLineSize = 288;
      break;
      case 's':
        this.maxShortTitleLineSize = 120;
        this.maxLongTitleLineSize = 144;
        this.maxSubTitleLineSize = 288;
      break;
      case 'm':
        this.maxShortTitleLineSize = 132;
        this.maxLongTitleLineSize = 156;
        this.maxSubTitleLineSize = 312;
      break;
      case 'l':
        this.maxShortTitleLineSize = 144;
        this.maxLongTitleLineSize = 180;
        this.maxSubTitleLineSize = 360;
      break;
      case 'xl':
        this.maxShortTitleLineSize = 132;
        this.maxLongTitleLineSize = 168;
        this.maxSubTitleLineSize = 348;
      break;
    }
  }

    Customizer.prototype.setContainer = function setContainer(container) {
          this.container = container;
      }

    Customizer.prototype.setSku = function setSku(sku) {
        this.sku = sku;
        this.compute(false, null, 0);
    }

    Customizer.prototype.compute = function compute(computeSubTitleFirst, inputId, currentPosition, isDefaultValue) {
        this.isTyping = false;
        this.count++;

        let sku = this.sku;
        if (sku.includes('MED')) {
          const subSku = sku.split('#');
          const firstPartSku = subSku[0].split('-');

          sku = firstPartSku[0] + '-' + firstPartSku[1] + '#' + subSku[1];
        }

        AkairosHttpServices.callPost('label/compute',
            {
                customData: {
                    labelSize: this.size,
                    labelSku: sku,
                    rawTitle: this.title,
                    rawSubtitle: this.text,
                    computeSubTitleFirst: computeSubTitleFirst,
                    count: this.count,
                }
            },
            (result) => {
                if (result.hasOwnProperty('data') && result.data.hasOwnProperty('customData')) {
                    const customData = result.data.customData;

                    if (customData.count === this.count && !this.isTyping) {
                        let resetText = false;

                        this.html = customData.html;
                        this.text = customData.rawSubTitle;
                        this.title = customData.rawTitle;
                        this.key = customData.key;
                        this.customTitle = customData.formattedTitle;
                        this.customText = customData.formattedSubTitle;
                        this.customTitleSize = customData.titleSizeClass;
                        this.customTopMargin = customData.topMarginClass;
                        this.customUnderTitleMargin = customData.underTitleMarginClass;
                        this.customUnderSubTitleMargin = customData.underSubTitleMarginClass;

                        if (isDefaultValue !== true) {
                            if (customData.maxSubTitleLines == 0) {
                                this.displaySubTitleInput = false;
                            } else {
                                if (!this.displaySubTitleInput && this.text == '') {
                                    this.text = this.defaultText;
                                    resetText = true;
                                }
                                this.displaySubTitleInput = true;
                            }

                            if (customData.maxTitleLines == 0) {
                                this.displayTitleInput = false;
                            } else {
                                if (!this.displayTitleInput && this.title == '') {
                                    this.title = this.defaultTitle;
                                    resetText = true;
                                }
                                this.displayTitleInput = true;
                            }

                            if (!resetText) {
                                this.draw(inputId, currentPosition);

                                $(':root').trigger("customizerChange", [this.key]);
                            } else {
                                this.compute(computeSubTitleFirst, inputId, currentPosition);
                            }
                        }
                    }
                }
            },
            (error) => {
                console.error(error);
            }, true);

    };

    Customizer.prototype.onKeyUpTitle = function onKeyUpTitle(input, evt) {
        if (evt.keyCode < 37 || evt.keyCode > 40) {
            if (this.timeoutKeyUpTitle != null) {
                clearTimeout(this.timeoutKeyUpTitle);
            }

            this.timeoutKeyUpTitle = setTimeout(upTitle, 200, this, input, evt);
        }

        function upTitle(customizer, input, event) {
            customizer.updateTitle(input.value);
            customizer.compute(true, input.id, evt.target.selectionStart);
        }
    }

    Customizer.prototype.onKeyUpSubTitle = function onKeyUpSubTitle(input, evt) {
        if (evt.keyCode < 37 || evt.keyCode > 40) {
            if (this.timeoutKeyUpSubTitle != null) {
                clearTimeout(this.timeoutKeyUpSubTitle);
            }

            this.timeoutKeyUpSubTitle = setTimeout(upSubTitle, 200, this, input, evt);
        }

        function upSubTitle(customizer, input, event) {
            input.value = input.value.replaceAll("'", "’");

            customizer.updateText(input.value);
            customizer.compute(false, input.id, evt.target.selectionStart);
        }
    }

    Customizer.prototype.onTyping = function onTyping(evt) {
        if (evt.keyCode < 37 || evt.keyCode > 40) {
            this.isTyping = true;
        }
    }

    Customizer.prototype.updateTitle = function updateTitle(title) {
        this.title = title;
    };

    Customizer.prototype.getTitle = function getTitle() {
        return this.title;
    };

    Customizer.prototype.updateText = function updateText(text) {
        this.text = text;
    };

    Customizer.prototype.getText = function getText() {
        return this.text;
    };

    Customizer.prototype.getCurrentKey = function getCurrentKey() {
        return this.key;
    };

    Customizer.prototype.resetKey = function resetKey() {
        this.key = null;
    };

    Customizer.prototype.setIsOpenCustomizer = function setIsOpenCustomizer(isOpenCustomizerFlag) {
        this.isOpenCustomizer = isOpenCustomizerFlag;
    };

    Customizer.prototype.getIsOpenCustomizer = function getIsOpenCustomizer() {
        return this.isOpenCustomizer;
    };

    Customizer.prototype.draw = function draw(inputId, currentPosition) {
      if (this.template != undefined && this.template != null) {
        let data = {
            html: this.html,
            title: this.title,
            text: this.text,
            displayTitleInput: this.displayTitleInput,
            displaySubTitleInput: this.displaySubTitleInput,
            locales: locales
        };

        if (this.getIsOpenCustomizer() == true) {
            this.container.parent('.label_customizer').show();
        } else {
            this.container.parent('.label_customizer').hide();
        }

        this.container.addClass('label_customizer__container--loading');
        this.container.html(this.template(data));
        this.container.removeClass('label_customizer__container--loading');

        if (inputId !== undefined && inputId !== null) {
            let newInput = document.getElementById(inputId);
            newInput.focus();
            newInput.setSelectionRange(currentPosition, currentPosition);
        }
      }
    };

    Customizer.prototype.getAsProperties = function getAsProperties() {
        let titleKey = locales.title;
        let textKey = locales.text;

        let properties = {
            '_rawTitle': this.title,
            '_rawText': this.text,
            '_customTitle': this.customTitle,
            '_customText': this.customText,
            '_customTitleSize': this.customTitleSize,
            '_customTopMargin': this.customTopMargin,
            '_customUnderTitleMargin': this.customUnderTitleMargin,
            '_customUnderSubTitleMargin': this.customUnderSubTitleMargin,
        };
        properties[titleKey] = this.title;
        properties[textKey] = this.text;

        return properties;
    }

    return Customizer;
})();

let GiftCard = (function () {
    'use strict';

    function GiftCard() {
        this.defaultName = '',
            this.defaultMessage = '',
            this.title = '',
            this.text = '',

            this.customName = '',
            this.customMessage = '',
            this.customTopMargin = 'gift-top-margin-2',

            this.maxGiftNameLineSize = 336,
            this.maxGiftMessageLineSize = 336,
            this.maxGiftNameLines = 3,
            this.maxGiftMessageLines = 12,
            this.giftNameLinesCount = 1,
            this.giftMessageLinesCount = 1,

            this.template;
        this.container;
    };

    GiftCard.prototype.init = function init(container, name, message, template) {
        this.defaultName = name;
        this.defaultMessage = message;
        this.template = template;
        this.container = container;
        this.updateName(name);
        this.updateMessage(message);

        this.computeName();
        this.computeMessage();

        this.draw();

        this.updateMessageCounter(message.length);
    };

    GiftCard.prototype.onKeyUpName = function onKeyUpName(input, evt) {
        this.updateName(input.value);
        this.computeName();
        this.draw();

        const currentPosition = evt.target.selectionStart;

        let newInput = document.getElementById(input.id);
        newInput.focus();
        const strLen = this.name.length * 2;
        newInput.setSelectionRange(currentPosition, currentPosition);
    }

    GiftCard.prototype.onKeyUpMessage = function onKeyUpMessage(input, evt) {
        this.updateMessage(input.value);
        this.computeMessage();
        this.draw();

        const currentPosition = evt.target.selectionStart;

        let newInput = document.getElementById(input.id);
        newInput.focus();
        const strLen = this.message.length * 2;
        newInput.setSelectionRange(currentPosition, currentPosition);

        this.updateMessageCounter(this.message.length);
    }

    GiftCard.prototype.onFocusMessage = function onFocusMessage(input, evt) {
        setTimeout(function (currentThis, input, evt) {
          let messageValue = input.value;

          if (messageValue.replace(/[\n\r]/g, '').localeCompare(currentThis.defaultMessage, 'fr', {sensitivity: 'base'}) == 1) {
              input.value = '';
              currentThis.onKeyUpMessage(input, evt);
          }
        }, 200, this, input, evt);
    }

    GiftCard.prototype.onFocusName = function onFocusMessage(input) {
    }

    GiftCard.prototype.updateMessageCounter = function updateMessageCounter(count) {
        let giftCardCountCurrent = document.getElementById('giftCardCountCurrent');
        giftCardCountCurrent.innerText = count;
    }

    GiftCard.prototype.updateName = function updateName(name) {
        this.name = name;
    };

    GiftCard.prototype.getName = function getName() {
        return this.name;
    };

    GiftCard.prototype.computeName = function computeName() {
        this.giftNameLinesCount = 1;

        // Calculate sizes
        let inputVal = this.name;
        inputVal = inputVal.charAt(0).toUpperCase() + inputVal.slice(1);

        let emojis = searchEmoji(inputVal);

        let finalVal = inputVal,
            giftNameSize = sizeOfSentence(inputVal, emojis);

        if (giftNameSize > this.maxGiftNameLineSize) {
            // Split line on each space
            const words = inputVal.split(' ');
            const wordsLength = words.length;

            if (wordsLength === 1) {
                // Delete last char
                inputVal = sliceString(inputVal, this.maxGiftNameLineSize);
                finalVal = sliceString(finalVal, this.maxGiftNameLineSize);
            } else {
                let lines = [];

                let currentLine = "";
                let currentSize = 0;

                for (let i = 0; i < wordsLength; i++) {
                    let wordSize = sizeOfSentence(words[i], searchEmoji(words[i]));
                    let currentSpaceSize = defaultSpaceSize;
                    let currentSpaceValue = defaultSpaceValue;

                    // Is it the first word of line ?
                    if (currentSize === 0) {
                        // Yes, don't add space at the length
                        currentSpaceSize = 0;
                        currentSpaceValue = "";
                    }

                    if ((currentSize + currentSpaceSize + wordSize) > this.maxGiftNameLineSize) {
                        if (lines.length < this.maxGiftNameLines - 1) {
                            // Add current line in lines
                            lines.push(currentLine);

                            // Reset current line information
                            currentLine = "";
                            currentSize = 0;

                            currentSpaceSize = 0;
                            currentSpaceValue = "";
                        }
                    }

                    currentLine = currentLine + currentSpaceValue + words[i];
                    currentSize += wordSize + currentSpaceSize;
                }

                // Handle last words
                if (currentSize > 0) {
                    // Add current line in lines
                    lines.push(currentLine);
                }

                // Update available lines
                giftNameLinesCount = lines.length;

                for (let i = 0; i < lines.length; i++) {
                    if (sizeOfSentence(lines[i], searchEmoji(lines[i])) > this.maxGiftNameLineSize) {
                        lines[i] = sliceString(lines[i], this.maxGiftNameLineSize);
                    }
                }

                finalVal = lines.join('<br />');
                inputVal = lines.join(' ');
            }
        }

        this.giftTopMargin = "gift-top-margin-" + (this.giftNameLinesCount + this.giftMessageLinesCount);

        finalVal = replaceEmoji(finalVal, emojis, "emoji-gift");

        this.name = inputVal;
        this.customName = finalVal;
    };

    GiftCard.prototype.updateMessage = function updateMessage(message) {
        this.message = message;
    };

    GiftCard.prototype.getMessage = function getMessage() {
        return this.message;
    };

    GiftCard.prototype.computeMessage = function computeMessage() {
        let inputVal = this.message;

        // Force uppercase on the first char
        inputVal = inputVal.charAt(0).toUpperCase() + inputVal.slice(1);

        let emojis = searchEmoji(inputVal);

        // Count \n
        let subTitleLines = inputVal.split('\n');

        // Count line of each size
        let hasLineTooLong = false;
        let firstLineIndexTooBig = 0;
        for (let i = 0; i < subTitleLines.length; i++) {
            if (sizeOfSentence(subTitleLines[i], searchEmoji(subTitleLines[i])) > this.maxGiftMessageLineSize) {
                hasLineTooLong = true;
                firstLineIndexTooBig = i;
                break;
            }
        }

        if (hasLineTooLong) {
            let keepArray = subTitleLines.slice(0, firstLineIndexTooBig);

            // Join lines with space
            let newInput = subTitleLines.splice(firstLineIndexTooBig, subTitleLines.length).join(' ');

            const words = newInput.split(' ');
            const wordsLength = words.length;

            let lines = [];

            let currentLine = "";
            let currentSize = 0;

            for (let i = 0; i < wordsLength; i++) {
                let wordSize = sizeOfSentence(words[i], searchEmoji(words[i]));
                let currentSpaceSize = defaultSpaceSize;
                let currentSpaceValue = defaultSpaceValue;

                // Is it the first word of line ?
                if (currentSize === 0) {
                    // Yes, don't add space at the length
                    currentSpaceSize = 0;
                    currentSpaceValue = "";
                }

                if (currentSize > 0 && (currentSize + currentSpaceSize + wordSize) > this.maxGiftMessageLineSize && lines.length <
                    this.maxGiftMessageLines) {
                    // Add current line in lines
                    lines.push(currentLine);

                    // Reset current line information
                    currentLine = "";
                    currentSize = 0;

                    currentSpaceSize = 0;
                    currentSpaceValue = "";
                }

                currentLine = currentLine + currentSpaceValue + words[i];
                currentSize += wordSize + currentSpaceSize;
            }

            // Handle last words
            if (currentSize > 0) {
                // Add current line in lines
                lines.push(currentLine);
            }

            subTitleLines = keepArray.concat(lines);
        }

        this.giftMessageLinesCount = subTitleLines.length;
        for (let i = 0; i < this.giftMessageLinesCount; i++) {
            if (sizeOfSentence(subTitleLines[i], searchEmoji(subTitleLines[i])) > this.maxGiftMessageLineSize) {
                let currentLineSize = 0;
                let currentLineValue = "";
                for (let j = 0; j < subTitleLines[i].length; j++) {
                    currentLineSize += sizeOfLetter(subTitleLines[i][j]);
                    if (currentLineSize > this.maxGiftMessageLineSize) {
                        break;
                    }
                    currentLineValue += subTitleLines[i][j];
                }

                subTitleLines[i] = currentLineValue;
            }
        }

        if (this.giftMessageLinesCount > this.maxGiftMessageLines) {
            subTitleLines = subTitleLines.splice(0, this.maxGiftMessageLines);
            this.giftMessageLinesCount = subTitleLines.length;
        }

        // Join each lines
        inputVal = subTitleLines.join('\n');

        let finalVal = inputVal.replace(/\n/g, "<br />");
        finalVal = replaceEmoji(finalVal, emojis, "emoji-gift");

        this.customTopMargin = "gift-top-margin-" + (this.giftNameLinesCount + this.giftMessageLinesCount);

        this.message = inputVal;
        this.customMessage = finalVal;
    };

    GiftCard.prototype.draw = function draw() {
        let data = {
            name: this.name,
            message: this.message,
            customName: this.customName,
            customMessage: this.customMessage,
            customTopMargin: this.customTopMargin,
        };
        this.container.html(this.template(data));
    };

    GiftCard.prototype.getAsProperties = function getAsProperties() {
        return {
            'De la part de': this.name,
            'Message ': this.message,
            '_customDelapart': this.customName,
            '_customMessage': this.customMessage,
            '_customGiftTopMargin': this.customTopMargin,
        };
    }

    return GiftCard;
})();

let Multi = (function () {
    'use strict';

    function Multi() {
        this.bundleContainer;
        this.multiAreasMapping;

        this.groups = [];

        this.selectedGroupIndex = 0;
        this.selectedBundle;

        this.mainPrice;
        this.variants = [];

        this.subPromises = [];

        this.bundlesToShow = 1;
    }

    Multi.prototype.init = function init(multiAreasMapping, bundleContainer, mainProduct, bundle) {
        this.multiAreasMapping = multiAreasMapping;

        this.mainPrice = mainProduct.price;

        this.variants = mainProduct.variants;

        this.bundleContainer = bundleContainer;
        this.selectedBundle = bundle;

        let tags = product.tags;
        let prefix = 'collection-';

        let bundleIndex = 0;
        for (let i = 0; i < tags.length; i++) {
            if (tags[i].startsWith(prefix)) {
                const splittedTag = tags[i].split(prefix);
                if (splittedTag.length == 2) {
                    let defaultBundleIndex = 0;
                    const defaultBundleSearch = splittedTag[1].split("#");
                    if (defaultBundleSearch.length == 2 && !isNaN(defaultBundleSearch[1])) {
                      defaultBundleIndex = defaultBundleSearch[1];
                    }

                    const collectionCode = defaultBundleSearch[0].split("_");

                    let collectionType = locales.plant;
                    if (collectionCode[0].includes("bougie")) {
                        collectionType = locales.candle;
                    } else if (collectionCode[0].includes("infusion")) {
                        collectionType = locales.infusion;
                    } else if (collectionCode[0].includes("accessoire")) {
                        collectionType = locales.accessory;
                    }

                    this.groups[bundleIndex] = {
                        collectionCode: collectionCode[0],
                        collectionType: collectionType,
                        bundles: [],
                        selected: false,
                        currentSelectedBundleIndex: defaultBundleIndex,
                        summary: "",
                    };

                    bundleIndex++;
                }
            }
        }

        // Group loading of collection
        let collectionByGroup = {};
        for (let i = 0; i < this.groups.length; i++) {
          let code = this.groups[i].collectionCode;
          if (!collectionByGroup.hasOwnProperty(code)) {
            collectionByGroup[code] = [];
          }
          collectionByGroup[code].push(i);
        }

        let promises = [];
        for (const key in collectionByGroup) {
          promises.push(this._loadCollectionOfProduct(key, collectionByGroup[key]));
        }

        return promises;
    };

    Multi.prototype._loadCollectionOfProduct = function _loadCollectionOfProduct(collectionCode, indexes) {
        var currentMulti = this;

        return jQuery.getJSON('/collections/' + collectionCode + '/products.json', function (collection) {
            if (collection.products.length > 0) {
              for (var i = 0; i < indexes.length; i++) {
                let bundles = [];
                collection.products.forEach(function (product) {
                    let instance = new Bundle();
                    let bundlePromises = instance.init(currentMulti.bundleContainer, product, "", true);
                    for (var i = 0; i < bundlePromises.length; i++) {
                      currentMulti.subPromises.push(bundlePromises[i]);

                    }
                    bundles.push(instance);
                });

                if (bundles.length > 0) {
                  currentMulti.groups[indexes[i]].bundles = bundles;

                  if (bundles.length < currentMulti.groups[indexes[i]].currentSelectedBundleIndex) {
                    currentMulti.groups[indexes[i]].currentSelectedBundleIndex = 0;
                  }
                }
              }
            }
        });
    };

    Multi.prototype.postInit = function postInit() {
        Promise.all(this.subPromises).then((values) => {
          var currentMulti = this;

          setTimeout(function () {
            for (let i = 0; i < currentMulti.groups.length; i++) {
                for (let j = 0; j < currentMulti.groups[i].bundles.length; j++) {
                    currentMulti.groups[i].bundles[j].postInit();
                }
                currentMulti.groups[i].summary = currentMulti.groups[i].bundles[currentMulti.groups[i].currentSelectedBundleIndex].getSummary(i);
            }

            setTimeout(function () {
                currentMulti.groups[currentMulti.selectedGroupIndex].selected = true;
                currentMulti.selectedBundle = currentMulti.groups[currentMulti.selectedGroupIndex].bundles[currentMulti.groups[currentMulti.selectedGroupIndex].currentSelectedBundleIndex];
                $(':root').trigger("multiLoaded", []);
            }, 500);
          }, 500);

        }, reason => {
          console.error(reason)
        });
    };

    Multi.prototype.viewAll = function viewAll() {
        this.bundlesToShow = this.groups.length;
        this.draw();
    }

    Multi.prototype.viewOnlyOne = function viewAll() {
        this.bundlesToShow = 1;
        this.draw();
    }

    Multi.prototype.toggleChoices = function toggleChoices(target) {

        $(':root').trigger("toggleChoices", ['target']);

        if (target) {
            // When open labels configuration in multi then force customized value to preactivate default correct tab
            if (target == 'product_options__labels') {
                this.selectedBundle.updateCustomized('personnalisation_classique');
            }

            $('#' + target).toggleClass('product_options__popup-mobile--active');
            $('.product_options__overlay').toggleClass('product_options__overlay--active');

        } else {
            $('.product_options__overlay').removeClass('product_options__overlay--active');
            $('.product_options__popup-mobile').removeClass('product_options__popup-mobile--active');
        }


    }

    Multi.prototype.updateSummary = function updateSummary() {
      const selectedBundle = this.selectedBundle;
      if (selectedBundle) {
        if (this.selectedBundle.getIsCustomized()) {
          const previewUrl = selectedBundle.getPreviewUrl(selectedBundle.customizer.getCurrentKey(), true);
        } else {
          const previewUrl = selectedBundle.getDefaultImageUrl();
        }

        $('#preview-' + this.selectedGroupIndex).attr("src", previewUrl);
      }
    }

    Multi.prototype.draw = function draw() {
        let data = {
            groups: this.groups,
            selectedBundleDefaultTitle: this.selectedBundle.defaultTitle,
            bundlesToShow: this.bundlesToShow,
            selectedGroupIndex: this.selectedGroupIndex,
            selectedBundle: this.selectedBundle
        };

        // Reset Product Options Overlay
        $('.product_options__overlay').removeClass('product_options__overlay--active');

        // Rendering each container html with own parsed template
        for (const [key, value] of Object.entries(multiAreasMapping)) {
            multiAreasMapping[key].container.html(multiAreasMapping[key].template(data));
        }

        var self = this;

        // Selected Bundle Draw
        this.selectedBundle.change();
        this.selectedBundle.draw();

        var slidesToShow = this.bundlesToShow;

        // Sliders
        var tabsTitles = [];
        $('.main-swiper .swiper-slide').each(function(){
            tabsTitles.push($(this).attr('data-collectiontype'));
        });

        const mainSwiper = new Swiper('.main-swiper', {
            slidesPerView: slidesToShow,
            spaceBetween: 10,
            zoom: false,
            freeMode: {
                enabled: true,
                sticky: true,
            },
            navigation: {
                nextEl: '.main-swiper--next',
                prevEl: '.main-swiper--prev',
            },
            pagination: {
                el: ".multiContainer__header__pagination",
                clickable: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '"><em>' + (index + 1) + '.</em> <em class="t">'+ tabsTitles[index] +'</em> </span>';
                },
            },
            on: {
                init: function () {
                    this.slideTo(self.selectedGroupIndex, false, false);

                    // on the first slide
                    if (this.activeIndex == 0) {
                        $('.main-swiper--prev, .main-swiper__bottom-navigation--prev span').hide();
                        $('.main-swiper--next, .main-swiper__bottom-navigation--next span').show();
                    }
                    // most right postion
                    else if (this.activeIndex == this.slides.length - 1) {
                        $('.main-swiper--prev, .main-swiper__bottom-navigation--prev span').show();
                        $('.main-swiper--next, .main-swiper__bottom-navigation--next span').hide();
                    }
                    // middle positions
                    else {
                        $('.main-swiper--prev, .main-swiper__bottom-navigation--prev span').show();
                        $('.main-swiper--next, .main-swiper__bottom-navigation--next span').show();
                    }
                },
                'transitionEnd': function () {
                    self.selectGroup(this.realIndex);
                }
            },
        });

        var currentSelectedBundleIndex = this.groups[this.selectedGroupIndex].currentSelectedBundleIndex;

        const plantsSwiper = new Swiper('.plants-swiper', {
            slidesPerView: 3,
            slidesPerGroup: 3,
            slideToClickedSlide: true,
            spaceBetween: 15,
            loop: false,
            centeredSlides: false,
            centeredSlidesBounds: false,
            freeMode: false,
            // Navigation arrows
            navigation: {
                nextEl: '.plants-swiper--next',
                prevEl: '.plants-swiper--prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                //dynamicBullets: true,
                renderBullet: function (index, className) {
                    return '<span class="' + className + '">' + (index + 1) + "</span>";
                },
            },
            on: {
                init: function () {
                    this.slideTo(currentSelectedBundleIndex, false, false);
                    this.update();
                    if (currentSelectedBundleIndex == 0) {
                        $('.plants-swiper .swiper-slide:first-child .plants-swiper__image_wrapper').addClass('selected');
                    }
                },
                'slideChange': function () {
                },
                'transitionEnd': function () {
                }
            },
            grabCursor: true,
            slidesPerGroupSkip: 0
        });
    }

    Multi.prototype.getCurrentBundle = function getCurrentBundle() {
        return this.selectedBundle;
    }

    Multi.prototype.selectGroup = function selectGroup(index) {
        for (let j = 0; j < this.groups.length; j++) {
            this.groups[j].selected = false;
            this.groups[j].summary = this.groups[j].bundles[this.groups[j].currentSelectedBundleIndex].getSummary(j);
        }

        this.selectedGroupIndex = index;
        this.groups[index].selected = true;
        this.selectedBundle = this.groups[this.selectedGroupIndex].bundles[this.groups[this.selectedGroupIndex].currentSelectedBundleIndex];
        //this.groups[index].summary = this.selectedBundle.getSummary();

        $(':root').trigger("multiChanged", []);
    }

    Multi.prototype.getCurrentSelectedGroupIndex = function getCurrentSelectedGroupIndex() {
      return this.selectedGroupIndex;
    }

    Multi.prototype.selectBundle = function selectBundle(index) {

        // Retrieve previous selected secondaryProduct to selected bundle, if not manual selected get default
        let previousSelectedSecondaryProduct     = this.groups[this.selectedGroupIndex].bundles[0].getSelectedSecondaryProduct();
        let previousSelectedLabel   = this.groups[this.selectedGroupIndex].bundles[0].getSelectedLabel();
        let previousCustomizer      = this.groups[this.selectedGroupIndex].bundles[0].getCustomizer();
        let previousLabelType       = this.groups[this.selectedGroupIndex].bundles[0].getLabelType();
        let previousIsCustomized    = this.groups[this.selectedGroupIndex].bundles[0].getIsCustomized();

        for (let j = 0; j < this.groups[this.selectedGroupIndex].bundles.length; j++) {
            if (this.groups[this.selectedGroupIndex].bundles[j].selected == true) {
                previousSelectedSecondaryProduct     = this.groups[this.selectedGroupIndex].bundles[j].getSelectedSecondaryProduct();
                previousSelectedLabel   = this.groups[this.selectedGroupIndex].bundles[j].getSelectedLabel();
                previousCustomizer      = this.groups[this.selectedGroupIndex].bundles[j].getCustomizer();
                previousLabelType       = this.groups[this.selectedGroupIndex].bundles[j].getLabelType();
                previousIsCustomized    = this.groups[this.selectedGroupIndex].bundles[j].getIsCustomized();
            }
        }

        for (let j = 0; j < this.groups[this.selectedGroupIndex].bundles.length; j++) {
            this.groups[this.selectedGroupIndex].bundles[j].selected = false;
        }

        if (previousSelectedSecondaryProduct) {
            this.groups[this.selectedGroupIndex].bundles[index].setSelectedSecondaryProduct(previousSelectedSecondaryProduct);
        }

        if (previousSelectedLabel) {
            this.groups[this.selectedGroupIndex].bundles[index].setSelectedLabel(previousSelectedLabel);
        }

        if (previousCustomizer) {
            this.groups[this.selectedGroupIndex].bundles[index].setCustomizer(previousCustomizer);
        }

        if (previousLabelType) {
            this.groups[this.selectedGroupIndex].bundles[index].setLabelType(previousLabelType);
        }

        if (previousIsCustomized) {
            this.groups[this.selectedGroupIndex].bundles[index].setIsCustomized(previousIsCustomized);
        }

        this.groups[this.selectedGroupIndex].bundles[index].selected = true;

        // Retrieve selected bundle's correct image
        this.groups[this.selectedGroupIndex].bundles[index].updateMainProductImageIndex();

        if (this.groups[this.selectedGroupIndex].bundles[index].customizer.getCurrentKey() !== null) {
            this.groups[this.selectedGroupIndex].bundles[index].setPreview(this.groups[this.selectedGroupIndex].bundles[index].customizer.getCurrentKey());
        }

        this.groups[this.selectedGroupIndex].currentSelectedBundleIndex = index;
        this.selectedBundle = this.groups[this.selectedGroupIndex].bundles[this.groups[this.selectedGroupIndex].currentSelectedBundleIndex];

        this.groups[this.selectedGroupIndex].currentSelectedBundleDefaultTitle = this.selectedBundle.defaultTitle;
        this.groups[this.selectedGroupIndex].summary = this.selectedBundle.getSummary(this.selectedGroupIndex);

        $(':root').trigger("multiChanged", []);
    }

    Multi.prototype.selectMainProductVariantForBundle = function selectMainProductVariantForBundle(selectedVariantIndex) {
      this.getCurrentBundle().selectMainProductVariant(selectedVariantIndex);
      $(':root').trigger("multiChanged", []);
    }

    Multi.prototype.isAvailable = function isAvailable() {
        return true;
    }

    Multi.prototype.getCurrentPrice = function getCurrentPrice() {
        let currentPrice = this.mainPrice;
        for (let j = 0; j < this.groups.length; j++) {
            let groupBundle = this.groups[j].bundles[this.groups[j].currentSelectedBundleIndex];
            if (typeof groupBundle == 'undefined') {
                return 0;
            }
            currentPrice += groupBundle.getPrice()
        }
        return currentPrice;
    }

    Multi.prototype.addToCart = function addToCart() {
        let productSelect = this.variants[0],
            multiId = productSelect.id + ":" + Date.now() + ":" + Math.floor(Math.random() * (95000 - 10000)) + 10000;

        let items = [];
        for (let j = this.groups.length - 1; j >= 0; j--) {
          items.push(...this.groups[j].bundles[this.groups[j].currentSelectedBundleIndex].addToCart());
        }

        let multiProperties = {
          '_rootMultiId': multiId
        };

        for (let j = 0; j < items.length; j++) {
            items[j].properties['_multiId'] = multiId;

            if (items[j].properties.hasOwnProperty('_rootBundleId')) {
              items[j].properties['_multiSku'] = productSelect.sku;
            }
        }

        items.push(
            {
                quantity: 1,
                id: this.variants[0].id,
                properties: multiProperties,
            }
        );

        return items;
    }

    Multi.prototype.updateCurrentBundlePreview = function updateCurrentBundlePreview(key) {
    }

    return Multi;
})();

let secondaryProductProducts = {},
    labelProducts = {},
    engravingProducts = {},
    saucerProducts = {},
    fertilizerProducts = {},
    productRecharges = {},
    upsellProducts= [],
    currentSecondaryProductVariantIndex = 1;

let Bundle = (function () {
    'use strict';

    function Bundle() {
        this.id = 0,
        this.images = [],
        this.currentImage,
        this.defaultImageBySecondaryProductSku = {};
        this.mainPrice,
        this.mainAvailable = false,
        this.isCustomizable = false,
        this.isCustomized = false,
        this.labelType = 'standard', // standard, personnalisation_classique, personnalisation_illustree
        this.hasSecondaryProduct = false,
        this.tags = [],
        this.sku = '',

        this.bundlePrice,
        this.bundleAvailable,

        this.customizer = null,

        this.currentMainVariantIndex = 0;
        this.currentMainVariantTitle = "";

        this.labelProduct = null,
        this.engravingProduct = null,
        this.selectedLabel = null,
        this.secondaryProductProduct = null,
        this.selectedSecondaryProduct = null,
        this.rechargeProduct = null,
        this.secondaryProductTypologies = [],
        this.currentSecondaryProductTypology = null,
        this.saucerProduct = null,
        this.selectedSaucer = null,

        this.size = '',
        this.productType = '',

        this.variants = [],
        this.hasManyVariants = false,

        this.container,
        this.logoUrl;

        this.hasManyLabel = false;
        this.hasManySecondaryProductTypology = false;

        this.previewURL = null;
        this.previewBackgroundURL = null;
        this.isInMulti = false;

        this.excludeCeramicSecondaryProduct = false;
        this.excludeMetalSecondaryProduct = false;

        this.enableUpsellSaucer = false;
        this.hasEngraving = false;
        this.hasLabel = false;
        this.hasNoCustom = false;

        this.secondaryProductType = null;
        this.engravingType = null;
        this.labelProductType = null;

        this.secondaryProductPropertyLabel = null;

        this.needFertilizer = false;
        this.fertilizerType = "";
        this.fertilizerProduct = null;
        this.selectedFertilizer = null;

        this.upsellCollectionCode = null;
        this.selectedUpsellProducts = {};
    };

    Bundle.prototype.init = function init(container, mainProduct, logoUrl, isInMulti) {

        this.container = container;
        this.logoUrl = logoUrl;
        this.isInMulti = isInMulti;

        const p = mainProduct;

        this.variants = p.variants;

        this.currentImage = p.images[0];

        for (var i = 0; i < this.variants.length; i++) {
          this.variants[i].selected = false;

          if (this.variants[this.currentMainVariantIndex].featured_image !== undefined && this.variants[this.currentMainVariantIndex].featured_image !== null) {
            if (this.currentImage.src === this.variants[this.currentMainVariantIndex].featured_image.src) {
              this.currentMainVariantIndex = i;
            }
          }
        }
        this.variants[this.currentMainVariantIndex].selected = true;

        if (this.variants[this.currentMainVariantIndex].featured_image !== undefined && this.variants[this.currentMainVariantIndex].featured_image !== null) {
          this.currentImage = this.variants[this.currentMainVariantIndex].featured_image;
        }

        if (this.variants[this.currentMainVariantIndex].option1) {
          this.currentMainVariantTitle = this.variants[this.currentMainVariantIndex].option1
        }

        if (this.variants[this.currentMainVariantIndex].option2) {
          if (this.currentMainVariantTitle != "") {
            this.currentMainVariantTitle += " / "
          }

          this.currentMainVariantTitle += this.variants[this.currentMainVariantIndex].option2
        }

        if (this.variants.length > 1) {
          this.hasManyVariants = true;
        }

        this.id = p.id;
        this.images = p.images;

        if (this.isInMulti === true) {
            this.mainPrice = 0;
        } else {
            this.mainPrice = p.price;
            if (typeof this.mainPrice == 'undefined') {
                let variantPrice = this.variants[this.currentMainVariantIndex].price;
                if (typeof variantPrice == 'string') {
                    const parsed = parseInt(variantPrice, 10);
                    if (isNaN(parsed)) {
                        this.mainPrice = undefined;
                    }
                    this.mainPrice = parsed * 100;
                } else {
                    this.mainPrice = variantPrice;
                }
            }
        }

        this.mainAvailable = p.available;
        this.sku = this.variants[this.currentMainVariantIndex].sku;

        this.isCustomizable = p.tags.includes("Customize");

        this.tags = p.tags;

        let prefix = 'upsell-';
        for (let i = 0; i < this.tags.length; i++) {
          if (this.tags[i].startsWith(prefix)) {
            const splittedTag = this.tags[i].split(prefix);
            if (splittedTag.length == 2) {
              this.upsellCollectionCode = splittedTag[1];
              break;
            }
          }
        }

        this.defaultTitle = p.title;

        let stringSeparator = 'puristes : ',
            subStringSeparator = 'dimensions';
        if (siteLang == "de") {
          stringSeparator = 'Botaniker:';
          subStringSeparator = /ABMESSUNGEN/i;
        }

        if (p.tags.includes("bougies-pot")) {
            stringSeparator = 'Fragrance : ';
            subStringSeparator = 'format';
            if (siteLang == "de") {
              stringSeparator = 'Duftnote:';
            }
            this.productType = 'CANDLE';
        } else {
            this.productType = 'PLANT';
        }

        if (p.tags.includes("out-of-stock-metal")) {
          this.excludeMetalSecondaryProduct = true;
        }
        if (p.tags.includes("out-of-stock-ceramic")) {
          this.excludeCeramicSecondaryProduct = true;
        }

        // if (p.tags.includes("plantes-pot")) {
        //   this.needFertilizer = true;
        //   this.fertilizerType = "elixir-du-desert";
        //   if (p.tags.includes("Plantes et palmiers")) {
        //     this.fertilizerType = "elixir-tropical";
        //   }
        // }

        let content = p.content;
        if (typeof content == 'undefined') {
            content = p.body_html;
        }

        const bodySplitted = stripHtml(content).split(stringSeparator);
        if (bodySplitted[1] !== undefined) {
            const partOfText = bodySplitted[1].split(subStringSeparator);
            this.defaultText = partOfText[0].replace(/(\r\n|\n|\r)/gm, "");
        }

        this.title = this.defaultTitle;
        this.text = this.defaultText;

        let type = p.type;
        if (type == undefined) {
            type = p.product_type;
        }

        let couldNeedSaucer = false;
        if (!type.includes("Pot") && !type.includes("Herbier") && !type.includes("Parfum") && !type.includes("Infusion")) {
          this.isCustomizable = false
        } else {
          switch (type) {
              case 'Pot XXS':
                  this.size = 'xxs';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.hasEngraving = true;
                  this.engravingType = 'engraving';
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Pot XS':
                  this.size = 'xs';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.hasEngraving = true;
                  this.engravingType = 'engraving';
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Pot S':
                  this.size = 's';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.hasEngraving = true;
                  this.engravingType = 'engraving';
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Pot M':
                  this.size = 'm';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.hasEngraving = true;
                  this.engravingType = 'engraving';
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Pot L':
                  this.size = 'l';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  couldNeedSaucer = true;
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Pot XL':
                  this.size = 'xl';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  couldNeedSaucer = true;
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
              case 'Herbier Personnalisable 2130':
                  this.size = '2130';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.secondaryProductType = 'frame';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.frame);
                  break;
              case 'Herbier Personnalisable 3040':
                  this.size = '3040';
                  this.hasLabel = true;
                  this.labelProductType = 'label';
                  this.secondaryProductType = 'frame';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.frame);
                  break;
              case 'Parfum XS':
                  this.size = 'xs';
                  this.hasEngraving = true;
                  this.hasNoCustom = true;
                  this.labelProductType = 'label';
                  this.engravingType = 'engraving-puck';
                  this.secondaryProductType = 'puck';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.puck);
                  break;
              case 'Parfum S':
                  this.size = 's';
                  this.hasEngraving = true;
                  this.hasNoCustom = true;
                  this.labelProductType = 'label';
                  this.engravingType = 'engraving-puck';
                  this.secondaryProductType = 'puck';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.puck);
                  break;
              case 'Infusion XS':
                  this.size = 'xs';
                  this.hasLabel = true;
                  this.labelProductType = 'label-infuser';
                  this.productType = 'INFUSER';
                  this.secondaryProductType = 'pot';
                  this.secondaryProductPropertyLabel = capitalizeFirstLetter(locales.pot);
                  break;
          }
        }

        if (this.size !== '') {
            this.hasSecondaryProduct = true;
        }

        if (this.hasLabel) {
          this.labelType = 'standard'
        } else if (this.hasNoCustom) {
          this.labelType = 'sans_personnalisation'
        } else if (this.hasEngraving) {
          this.labelType = 'gravure_personnalisee'
        }

        let promises = [];
        let size = this.size;
        let productId = this.id;

        // Load SecondaryProduct
        if (this.hasSecondaryProduct) {
            if (secondaryProductProducts[size] === undefined) {
                secondaryProductProducts[size] = {};
                let productImages = this.images;

                var excludeMetalSecondaryProduct = this.excludeMetalSecondaryProduct;
              	var excludeCeramicSecondaryProduct = this.excludeCeramicSecondaryProduct;

                var secondaryType = this.secondaryProductType;

                promises.push(jQuery.getJSON('/products/' + this.secondaryProductType + '-' + size + '.js', function (product) {
                    for (let i = 0; i < product.variants.length; i++) {
                        let v = product.variants[i];

                        v.hide = true;
                        if (v.featured_image) {
                            v.hide = false;
                        }

                        const skuParts = v.sku.split('-');
                        v.mainProductImageIndex = -1;
                        for (let j = 0; j < productImages.length; j++) {
                            let imageUrl = "";
                            if (typeof productImages[j] == 'string') {
                                imageUrl = productImages[j];
                            } else {
                                imageUrl = productImages[j].src;
                            }

                            if (imageUrl.indexOf(skuParts[1]) != -1) {
                                v.mainProductImageIndex = j;

                                if (j == 0) {
                                    currentSecondaryProductVariantIndex = 0;
                                }

                                break;
                            }
                        }

                        v.onlyForPlant = false;

                        if (secondaryType == 'pot') {
                          //if (skuParts[1].startsWith('C') || (skuParts[0] == 'XS' && skuParts[1] == 'MCOP1')) {
                          if ((skuParts[0] == 'XS' && skuParts[1] == 'MCOP1') || (skuParts[0] == 'S' && v.option3 == 'Cannelé')) {
                              v.onlyForPlant = true;
                          }

                          if (skuParts[1].startsWith('C')) {
                            v.material = "ceramic";
                            if (excludeCeramicSecondaryProduct == true) {
                              v.hide = true;
                              v.available = false;
                            }
                          } else {
                            v.material = "metal";
                            if (excludeMetalSecondaryProduct == true) {
                              v.hide = true;
                              v.available = false;
                            }
                          }
                        }

                        let optionText = v.option2;
                        if (optionText === "" || optionText === null || optionText === undefined) {
                          optionText = v.option1;
                        }
                        v.currentName = optionText;

                        v.productTypeTitle = locales[secondaryType];
                    }
                    secondaryProductProducts[size] = product;
                }));
            }
        }

        // Load Label
        if (this.isCustomizable) {
            if (labelProducts[size] === undefined) {
                labelProducts[size] = {};
                promises.push(jQuery.getJSON('/products/' + this.labelProductType + '-' + size + '.js', function (product) {
                    for (let i = 0; i < product.variants.length; i++) {
                      let v = product.variants[i];
                      v.isLabel = true;
                    }
                    labelProducts[size] = product;
                }));
            }
            if (this.hasEngraving && engravingProducts[size] === undefined) {
                engravingProducts[size] = {};
                promises.push(jQuery.getJSON('/products/' + this.engravingType + '-' + size + '.js', function (product) {
                    for (let i = 0; i < product.variants.length; i++) {
                      let v = product.variants[i];
                      v.isEngraving = true;

                      if (v.sku.includes("GRAVURE-AMOUR")) {
                        v.defaultText = "Love";
                        v.declinedPreview = 1;
                      }
                    }
                    engravingProducts[size] = product;
                }));
            }
            if (couldNeedSaucer && saucerProducts[size] === undefined) {
                saucerProducts[size] = {};
                promises.push(jQuery.getJSON('/products/saucer-' + size + '.js', function (product) {
                    saucerProducts[size] = product;
                }));
            }
        }

        if (this.needFertilizer && fertilizerProducts[this.fertilizerType] === undefined) {
          let fType = this.fertilizerType;
          fertilizerProducts[this.fertilizerType] = {};
          promises.push(jQuery.getJSON('/products/' + this.fertilizerType + '.js', function (product) {
              fertilizerProducts[fType] = product;
          }));
        }

        if (this.upsellCollectionCode !== null) {
          promises.push(jQuery.getJSON('/collections/' + this.upsellCollectionCode + '/products.json', function (collection) {
            if (collection.products.length > 0) {
              collection.products.forEach(function (product) {

                for (let j = 0; j < product.variants.length; j++) {
                  product.variants[j].formattedPrice = " (+" + new Intl.NumberFormat(userLang, {
                      style: 'currency',
                      currency: currencyCode,
                      minimumFractionDigits: 0,
                      maximumFractionDigits: 0
                  }).format(parseFloat(product.variants[j].price)) + ")";

                  if (product.variants[j].title === "Default Title") {
                    product.variants[j].title = product.title;
                  }

                  if (product.variants[j].featured_image === null) {
                    product.variants[j].featured_image = product.images[0];
                  }
                }

                upsellProducts.push(product);
              });
            }
          }));
        }

        // Load Product Recharge
        promises.push(jQuery.ajax({
            url: '/products/' + p.handle + '?view=metafields.json',
            success: function (data) {
                if ($.trim(data) != '') {
                    var product_data = JSON.parse(data);
                    productRecharges[productId] = product_data;
                }
            }
        }));

        return promises;
    };

    Bundle.prototype.initSecondaryProductsFilter = function initSecondaryProductsFilter() {
        var $filter = $('.potsFilter');
        var $tab = $('.potsFilter a');
        var $secondaryProducts = $('#bundlePotSelector .pot');
        var fadeIn = 300;
        var fadeOut = 100;
        var b = this;

        $('.potsFilter a').on('click touch', function(e){
            e.preventDefault();
            var group = $(this).attr('data-group');

            $secondaryProducts.filter('.' + group).fadeIn( fadeIn );

            b.currentSecondaryProductTypology = group;

            for (let i = 0; i < b.secondaryProductTypologies.length; i++) {
              if (b.secondaryProductTypologies[i].typologyCode == b.currentSecondaryProductTypology) {
                b.secondaryProductTypologies[i].selected = true;
              } else {
                b.secondaryProductTypologies[i].selected = false;
              }
            }

            if (b.currentSecondaryProductTypology == 'standard') {
              b.labelProduct = labelProducts[b.size];
              b.engravingProduct = engravingProducts[b.size];
              b.isCustomizable = true;
            } else {
              b.labelProduct = null;
              b.isCustomizable = false;
              b.updateCustomized("standard", null)
            }

            // Check if selected Label is in labelProduct variants
            let selectedLabelIsIn = false;
            let availableLabel = 0;
            if (b.selectedLabel != null && b.labelProduct != null) {
              for (let i = 0; i < b.labelProduct.variants.length; i++) {
                  let variant = b.labelProduct['variants'][i];
                  if (variant.id == b.selectedLabel.id) {
                    selectedLabelIsIn = true;
                    break
                  }
              }
              if (!selectedLabelIsIn) {
                b.selectedLabel = null;
              }
            }

            if (b.selectedLabel == null && b.labelProduct != null) {
              for (let i = 0; i < b.labelProduct.variants.length; i++) {
                  let variant = b.labelProduct['variants'][i];

                  if (variant.available && variant.price > 0) {
                      availableLabel++;
                      if (b.selectedLabel == null) {
                        b.selectedLabel = variant;
                      }
                  }
              }

              if (availableLabel > 1) {
                b.hasManyLabel = true;
              } else {
                b.hasManyLabel = false;
              }

              if (b.currentSecondaryProductTypology == 'standard') {
                if (b.hasLabel) {
                  b.labelType = "standard";
                } else {
                  b.labelType = "sans_personnalisation";
                }
              } else {
                b.labelType = "gravure_personnalisee";
              }

              b.initCustomizer(false);
            }

            // Check if selected secondaryProduct has current typologyCode
            const found = b.selectedSecondaryProduct.typologies.find(element => element == group);
            if (found == undefined) {
              // Search first secondaryProduct for group
              $secondaryProducts.filter('.' + group).first().click();
            }

            b.draw();
        });

        $secondaryProducts.filter('.' + this.currentSecondaryProductTypology).fadeIn( fadeIn );
    };

    Bundle.prototype.postInit = function postInit() {

        if (this.hasSecondaryProduct && this.secondaryProductProduct == null) {

            this.secondaryProductProduct = secondaryProductProducts[this.size];

            let hasLabel = false;
            let hasNoCustom = false;

            let enableUpsellSaucer = false;
            if (this.secondaryProductProduct.tags.includes("upsell-saucer")) {
              enableUpsellSaucer = true;
            }

            for (let i = 0; i < this.secondaryProductProduct.variants.length; i++) {
              let v = this.secondaryProductProduct.variants[i];

              const skuParts = v.sku.split('-');
              for (let j = 0; j < this.images.length; j++) {
                  let imageUrl = "";
                  if (typeof this.images[j] == 'string') {
                      imageUrl = this.images[j];
                  } else {
                      imageUrl = this.images[j].src;
                  }

                  if (imageUrl.indexOf(skuParts[1]) != -1) {
                    this.defaultImageBySecondaryProductSku[v.sku] = j;
                    break;
                  }
              }

              v.engravingIncludeOnlySku = [];
              v.engravingExcludeSku = [];
              v.declinedPreview = null;

              if (v.option3 == "Modulaire") {
                if (!this.isInMulti) {
                  v.typologies = ["standard"];
                  hasLabel = true;
                  v.hasLabel = true;
                  v.enableUpsellSaucer = enableUpsellSaucer;
                } else {
                  this.secondaryProductProduct.variants.splice(i, 1);
                }
              } else if (v.option3 == "Châteaux d'eau") {
                if (!this.isInMulti) {
                  v.typologies = ["noCustom"];
                  if (v.available) {
                    hasNoCustom = true;
                  }
                } else {
                  this.secondaryProductProduct.variants.splice(i, 1);
                }
              } else if (v.option3 == "collection bleu") {
                if (!this.isInMulti) {
                  v.typologies = ["noCustom"];
                  if (v.available) {
                    hasNoCustom = true;
                  }
                } else {
                  this.secondaryProductProduct.variants.splice(i, 1);
                }
              } else if (v.option3 == "Cannelé") {
                  v.typologies = ["standard"];
                  v.hasEngraving = false;
                  v.hasLabel = true;
                  hasLabel = true;
              } else if (v.option3 == "Amour") {
                  v.typologies = ["standard"];
                  v.hasLabel = true;
                  v.engravingIncludeOnlySku = ["GRAVURE-AMOUR"];
                  v.hasEngraving = true;
                  hasLabel = true;
              } else {
                v.typologies = ["standard"];
                v.hasEngraving = true;
                v.hasLabel = true;
                hasLabel = true;
                if (this.size == "m") {
                  v.hasEngraving = false;
                }
                v.engravingExcludeSku = ["GRAVURE-AMOUR"];
              }
            }

            this.secondaryProductTypologies = [{
              typologyCode: 'standard',
              typologyTitle: 'Pots personnalisables',
              selected: false,
              hasSecondaryProduct: hasLabel
            }]

            if (this.productType == "PLANT") {
              this.secondaryProductTypologies.push({
                typologyCode: 'noCustom',
                typologyTitle: 'Pots design',
                selected: false,
                hasSecondaryProduct: hasNoCustom
              });
            }

            let countAvailableSecondaryProductTypology = 0;
            for (let i = 0; i < this.secondaryProductTypologies.length; i++) {
              if (this.secondaryProductTypologies[i].hasSecondaryProduct) {
                countAvailableSecondaryProductTypology++;
              }
            }
            if (countAvailableSecondaryProductTypology > 1) {
              this.hasManySecondaryProductTypology = true;
            }

            let firstAvailableVariant = null;
            for (let i = 0; i < this.secondaryProductProduct['variants'].length; i++) {
                let variant = this.secondaryProductProduct['variants'][i];

                if (variant.available && !variant.hide) {
                    if (firstAvailableVariant == null) {
                        firstAvailableVariant = variant;
                    }

                    if (variant.mainProductImageIndex == currentSecondaryProductVariantIndex) {
                        this.selectedSecondaryProduct = variant;
                        break;
                    }
                }
            }

            if (this.selectedSecondaryProduct == null && firstAvailableVariant != null) {
                  this.selectedSecondaryProduct = firstAvailableVariant;
            }

            this.currentSecondaryProductTypology = this.secondaryProductTypologies[0].typologyCode;
            loop1:
            for (let j = 0; j < this.selectedSecondaryProduct.typologies.length; j++) {
              loop2:
              for (let k = 0; k < this.secondaryProductTypologies.length; k++) {
                if (this.secondaryProductTypologies[k].typologyCode == this.selectedSecondaryProduct.typologies[j]) {
                  this.currentSecondaryProductTypology = this.secondaryProductTypologies[k].typologyCode;
                  this.secondaryProductTypologies[k].selected = true;
                  break loop1;
                }
              }
            }

            if (this.currentSecondaryProductTypology == 'standard') {
              this.isCustomizable = true;
            } else {
              this.isCustomizable = false;
            }
        }

        if (saucerProducts[this.size] !== undefined) {
          this.saucerProduct = saucerProducts[this.size];
        }

        if (fertilizerProducts[this.fertilizerType] !== undefined) {
          this.fertilizerProduct = fertilizerProducts[this.fertilizerType];
        }

        if (this.rechargeProduct == null && typeof productRecharges[this.id] !== 'undefined') {
            this.rechargeProduct = productRecharges[this.id];
        }

        if (this.selectedSecondaryProduct !== null && this.selectedSecondaryProduct.mainProductImageIndex != -1) {
          if (siteLang == "de") {
            this.setPreview("STANDARD-" + this.sku);
            $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], imageZoom[this.selectedSecondaryProduct.mainProductImageIndex]]);
          } else {
            let iZoom = null;
            if (imageZoom !== undefined && imageZoom[this.selectedSecondaryProduct.mainProductImageIndex] !== undefined) {
              iZoom = imageZoom[this.selectedSecondaryProduct.mainProductImageIndex];
            }

            $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], iZoom]);
            this.updatePreview(this.images[this.selectedSecondaryProduct.mainProductImageIndex], null);
          }
        }

        // Label
        let preselectedVariantLabelSku = null;

        this.customizer = new Customizer();
        if (this.isCustomizable && this.labelProduct == null) {
            if (this.currentSecondaryProductTypology == 'standard') {
              this.labelProduct = labelProducts[this.size];
              this.engravingProduct = engravingProducts[this.size];
            }

            for (let i = 0; i < this.tags.length; i++) {
                if (this.tags[i].startsWith('PRESELECT-LABEL')) {
                    preselectedVariantLabelSku = this.tags[i].replace('PRESELECT-LABEL-', "");
                    break;
                }
            }

            let currentLabel = this.labelProduct;
            if (this.labelType === 'gravure_personnalisee') {
              currentLabel = this.engravingProduct;
            }

            let availableLabel = 0;
            let firstAvailableLabel = null;
            let openCustomizer = false;
            for (let i = 0; i < currentLabel.variants.length; i++) {
                let variant = currentLabel['variants'][i];

                if (variant.available) {
                    availableLabel++;
                    if (this.selectedLabel == null) {
                      if (firstAvailableLabel === null) {
                          firstAvailableLabel = variant;
                      }

                      if (preselectedVariantLabelSku !== null) {
                          if (variant.sku.endsWith(preselectedVariantLabelSku)) {
                              this.selectedLabel = variant;
                              openCustomizer = true;
                          }
                      } else {
                          this.selectedLabel = variant;
                      }
                    }
                }
            }

            if (availableLabel > 1) {
                this.hasManyLabel = true;
            }

            if (this.selectedLabel == null) {
                this.selectedLabel = firstAvailableLabel;
            }

            this.initCustomizer(false);

            if (openCustomizer === true) {
                this.updateCustomized();
            }
        }

        if (this.selectedSecondaryProduct !== null) {
          this.previewBackgroundURL = this.getBackgroundUrl();
        }

        this.draw();
        this.change();

        if (preselectedVariantLabelSku !== null && this.selectedLabel !== null) {
            this.selectLabel(this.selectedLabel.id);
            this.updateCustomized('personnalisation_illustree', this.selectedLabel);
        }

        $(':root').trigger("bundleLoaded", [this]);
    };

    Bundle.prototype.updateMainProductImageIndex = function updateMainProductImageIndex() {

        // if (typeof potProducts[this.size] !== undefined) {
        //
        //     let productImages = this.images;
        //
        //     for (let i = 0; i < potProducts[this.size].variants.length; i++) {
        //
        //         potProducts[this.size].variants[i].hide = true;
        //         if (potProducts[this.size].variants[i].featured_image) {
        //             potProducts[this.size].variants[i].hide = false;
        //         }
        //
        //         const skuParts = potProducts[this.size].variants[i].sku.split('-');
        //         potProducts[this.size].variants[i].mainProductImageIndex = -1;
        //
        //         for (let j = 0; j < productImages.length; j++) {
        //
        //             let imageUrl = "";
        //             if (typeof productImages[j] == 'string') {
        //                 imageUrl = productImages[j];
        //             } else {
        //                 imageUrl = productImages[j].src;
        //             }
        //
        //             if (imageUrl.indexOf(skuParts[1]) != -1) {
        //                 potProducts[this.size].variants[i].mainProductImageIndex = j;
        //
        //                 if (j == 0) {
        //                     currentPotVariantIndex = 0;
        //                 }
        //
        //                 break;
        //             }
        //         }
        //     }
        // }
    };

    Bundle.prototype.initCustomizer = function initCustomizer(computeOnLoad) {
        const customizerTemplate = Handlebars.compile($("#customizerTemplate").html());
        this.customizer.init($('#customizerContainer'), this.selectedLabel.sku, this.size, this.title, this.text, customizerTemplate, this.logoUrl, computeOnLoad);
    }

    Bundle.prototype.updateCustomized = function updateCustomized(labelType, forceLabel) {

        this.selectedLabel = null;
        let currentCustomProduct = null;
        switch (labelType) {
          case 'sans_personnalisation':
              this.isCustomized = false;
              this.labelType = labelType;

              break;

          case 'standard':
              this.isCustomized = false;
              this.labelType = labelType;

              break;

          case 'personnalisation_classique':
              this.isCustomized = true;
              this.labelType = labelType;
              currentCustomProduct = this.labelProduct;

              break;

          case 'gravure_personnalisee':
              this.isCustomized = true;
              this.labelType = labelType;
              currentCustomProduct = this.engravingProduct;

              break;
          default:
        }

        let availableLabel = 0;
        let newSelectedLabel = null;
        let defaultSelectedLabel = null;
        if (currentCustomProduct !== null) {
          for (let i = 0; i < currentCustomProduct.variants.length; i++) {
              let variant = currentCustomProduct['variants'][i];
              if (variant.available) {
                  availableLabel++;

                  if (defaultSelectedLabel === null) {
                    defaultSelectedLabel = variant;
                  }

                  if (forceLabel !== null && forceLabel !== undefined && variant.id === forceLabel.id) {
                    newSelectedLabel = variant;
                  }
              }
          }
        }

        if (newSelectedLabel !== null) {
          this.selectedLabel = newSelectedLabel;
        }

        if (this.selectedLabel === null) {
          this.selectedLabel = defaultSelectedLabel;
        }

        this.hasManyLabel = false;
        if (availableLabel > 1) {
            this.hasManyLabel = true;
        }

        if (this.isCustomized === true) {
            this.customizer.setIsOpenCustomizer(true);
            this.selectLabel(this.selectedLabel.Id);
        } else {
            this.customizer.setIsOpenCustomizer(false);
            this.customizer.resetKey();
            this.draw();
            if (this.selectedSecondaryProduct !== null) {
              if (siteLang == "de") {
                this.setPreview("STANDARD-" + this.sku);
                $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], imageZoom[this.selectedSecondaryProduct.mainProductImageIndex]]);
              } else {
                this.updatePreview(this.images[this.selectedSecondaryProduct.mainProductImageIndex], null);
              }
            }
        }

        this.change();
    };

    Bundle.prototype.getLabelType = function getLabelType() {
        return this.labelType;
    }

    Bundle.prototype.setLabelType = function setLabelType(labelType) {
        this.labelType = labelType;
    }

    Bundle.prototype.getIsCustomized = function getIsCustomized() {
        return this.isCustomized;
    }

    Bundle.prototype.setIsCustomized = function setIsCustomized(isCustomized) {
        this.isCustomized = isCustomized;
    }

    Bundle.prototype.getCustomizer = function getCustomizer() {
        return this.customizer;
    }

    Bundle.prototype.setCustomizer = function setCustomizer(customizer) {
        return this.customizer = customizer;
    }

    Bundle.prototype.getSelectedSecondaryProduct = function getSelectedSecondaryProduct() {
        return this.selectedSecondaryProduct;
    }

    Bundle.prototype.setSelectedSecondaryProduct = function setSelectedSecondaryProduct(selectedSecondaryProduct) {
        return this.selectedSecondaryProduct = selectedSecondaryProduct;
    }

    Bundle.prototype.getSelectedLabel = function getSelectedLabel() {
        return this.selectedLabel;
    }

    Bundle.prototype.setSelectedLabel = function setSelectedLabel(selectedLabel) {
        this.selectedLabel = selectedLabel;
    }

    Bundle.prototype.selectSecondaryProduct = function selectSecondaryProduct(newId) {
        let variants = this.secondaryProductProduct.variants;
        for (let i = 0; i < variants.length; i++) {
            let variant = variants[i];
            if (variant.id == newId) {
                this.selectedSecondaryProduct = variant;
                break;
            }
        }

        if (this.isInMulti) {
            this.updateMainProductImageIndex();
        }

        if (!this.selectedSecondaryProduct.enableUpsellSaucer) {
          this.selectedSaucer = null;
        }

        if (!this.selectedSecondaryProduct.hasEngraving && this.selectedLabel !== null && this.selectedLabel.isEngraving === true) {
          this.selectedLabel = null;
          this.labelType = 'standard';
          this.customizer.setIsOpenCustomizer(false);
          this.customizer.resetKey();
          this.setIsCustomized(false);
        } else if (!this.selectedSecondaryProduct.hasLabel && (this.selectedLabel === null || (this.selectedLabel !== null && this.selectedLabel.isLabel === true))) {
          this.selectedLabel = null;
          this.labelType = 'gravure_personnalisee';
          this.customizer.setIsOpenCustomizer(true);
          this.customizer.resetKey();
          this.setIsCustomized(true);
        }

        this.draw();

        this.customizer.setContainer($('#customizerContainer'));
        this.customizer.draw(null, 0);

        if (this.customizer.getCurrentKey() !== null) {
            this.setPreview(this.customizer.getCurrentKey());
            $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], imageZoom[this.selectedSecondaryProduct.mainProductImageIndex]]);
        } else {
            if (siteLang == "de") {
              this.setPreview("STANDARD-" + this.sku);
              $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], imageZoom[this.selectedSecondaryProduct.mainProductImageIndex]]);
            } else {
              if (this.selectedSecondaryProduct.mainProductImageIndex == -1) {
                this.selectedSecondaryProduct.mainProductImageIndex = 0;
              }
              $(':root').trigger("secondaryProductChange", [this.images[this.selectedSecondaryProduct.mainProductImageIndex], imageZoom[this.selectedSecondaryProduct.mainProductImageIndex]]);
              this.updatePreview(this.images[this.selectedSecondaryProduct.mainProductImageIndex], null);
            }
        }

        if (this.isInMulti === true) {
            $(':root').trigger("secondaryProductInMultiChange", []);
        }

        this.change();
    };

    Bundle.prototype.selectLabel = function selectLabel(newId) {
        let variants = this.labelProduct.variants;
        if (this.labelType === 'gravure_personnalisee') {
          variants = this.engravingProduct.variants;
        }

        for (let i = 0; i < variants.length; i++) {
            let variant = variants[i];
            if (variant.id == newId) {
                this.selectedLabel = variant;
                break;
            }
        }

        this.draw();
        this.customizer.setContainer($('#customizerContainer'));
        this.customizer.setSku(this.selectedLabel.sku);

        if (this.selectedLabel.sku.includes("GRAVURE-AMOUR") && this.selectedLabel.defaultText !== undefined) {
          this.customizer.updateText(this.selectedLabel.defaultText);
          this.customizer.compute(true, null, 0);
        }
    };

    Bundle.prototype.selectSaucer = function selectSaucer(newId) {
      if (newId !== null) {
        let variants = this.saucerProduct.variants;
        for (let i = 0; i < variants.length; i++) {
            let variant = variants[i];
            if (variant.id == newId) {
                this.selectedSaucer = variant;
                break;
            }
        }
      } else {
        this.selectedSaucer = null;
      }

      this.draw();
      this.customizer.setContainer($('#customizerContainer'));
      this.customizer.draw(null, 0);

      if (this.customizer.getCurrentKey() !== null) {
          this.setPreview(this.customizer.getCurrentKey());
      } else {
        this.updatePreview(this.images[this.selectedSecondaryProduct.mainProductImageIndex], null);
      }

      this.change();
    }

    Bundle.prototype.selectFertilizer = function selectFertilizer(newId) {
      if (newId !== null) {
        let variants = this.fertilizerProduct.variants;
        for (let i = 0; i < variants.length; i++) {
            let variant = variants[i];
            if (variant.id == newId) {
                this.selectedFertilizer = variant;
                break;
            }
        }
      } else {
        this.selectedFertilizer = null;
      }

      this.draw();

      this.customizer.setContainer($('#customizerContainer'));
      this.customizer.draw(null, 0);

      this.change();
    }

    Bundle.prototype.selectUpsellOption = function selectUpsellOption(newId) {

      if (newId !== null) {
        if (this.selectedUpsellProducts[newId] === undefined || this.selectedUpsellProducts[newId] === null) {
          for (let i = 0; i < upsellProducts.length; i++) {
            for (let j = 0; j < upsellProducts[i].variants.length; j++) {
              let variant = upsellProducts[i].variants[j];
              if (variant.id == newId) {
                  this.selectedUpsellProducts[newId] = variant;
                  break;
              }
            }
          }
        } else {
          delete this.selectedUpsellProducts[newId];
        }
      }

      this.draw();

      this.customizer.setContainer($('#customizerContainer'));
      this.customizer.draw(null, 0);

      this.change();
    }

    Bundle.prototype.hasSaucer = function hasSaucer() {
      return this.selectedSaucer != null;
    }

    Bundle.prototype.getSaucerImgUrl = function getSaucerImgUrl() {
      if (this.selectedSaucer != null) {
        let sku = this.selectedSaucer.sku;
        let sub = sku.replace(/-/g, '/');
        sub = sub.slice(0, sub.lastIndexOf("/"))

        return  '//' + AkairosApiHost + '/storage/assets/img/products/' + sub + '/' + sku + '.png';
      }
      return null;
    }

    Bundle.prototype.selectMainProductVariant = function selectMainProductVariant(index) {
      this.currentMainVariantIndex = index;

      for (var i = 0; i < this.variants.length; i++) {
        this.variants[i].selected = false;
      }
      this.variants[this.currentMainVariantIndex].selected = true;

      if (this.variants[this.currentMainVariantIndex].option1) {
        this.currentMainVariantTitle = this.variants[this.currentMainVariantIndex].option1
      }

      if (this.variants[this.currentMainVariantIndex].option2) {
        if (this.currentMainVariantTitle != "") {
          this.currentMainVariantTitle += " / "
        }

        this.currentMainVariantTitle += this.variants[this.currentMainVariantIndex].option2
      }

      this.currentImage = this.images[0];
      if (this.variants[this.currentMainVariantIndex].featured_image !== undefined && this.variants[this.currentMainVariantIndex].featured_image !== null) {
        this.currentImage = this.variants[this.currentMainVariantIndex].featured_image;
      }

      this.draw();

      this.updatePreview(this.currentImage.src, null);

      if (this.isInMulti === true) {
          $(':root').trigger("mainVariantInMultiChange", []);
      }

      this.change();
    }

    Bundle.prototype.draw = function draw() {
        let labelPrice = '';
        if (this.labelProduct != null && this.labelProduct.variants[0] != null) {
            labelPrice = new Intl.NumberFormat(userLang, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(this.labelProduct.variants[0].price / 100);
        }

        let engravingPrice = '';
        if (this.engravingProduct != null && this.engravingProduct.variants[0] != null) {
            engravingPrice = new Intl.NumberFormat(userLang, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(this.engravingProduct.variants[0].price / 100);
        }

        let variantSku = "xxxx";
        let secondaryProductPrice = '';
        let secondaryProduct = null;
        if (this.hasSecondaryProduct) {
          secondaryProduct = JSON.parse(JSON.stringify(this.secondaryProductProduct));
          for (let i = 0; i < secondaryProduct.variants.length; i++) {
              let variant = secondaryProduct.variants[i];
              if (variant.id == this.selectedSecondaryProduct.id) {
                  secondaryProduct.variants[i].selected = true;
                  break;
              }
          }

          for (let i = 0; i < secondaryProduct.variants.length; i++) {
              let variant = secondaryProduct.variants[i];
              if (this.productType === 'CANDLE' && variant.onlyForPlant) {
                  variant.hide = true;
              }
              if (this.excludeMetalSecondaryProduct && variant.material === "metal") {
                variant.hide = true;
              }
              if (this.excludeCeramicSecondaryProduct && variant.material === "ceramic") {
                variant.hide = true;
              }
          }

          if (this.selectedSecondaryProduct.price != 0) {
              secondaryProductPrice = " (+" + new Intl.NumberFormat(userLang, {
                  style: 'currency',
                  currency: currencyCode,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
              }).format(this.selectedSecondaryProduct.price / 100) + ")";
          }

          let secondaryProductSku = this.selectedSecondaryProduct.sku;
          variantSku = secondaryProductSku.slice(secondaryProductSku.lastIndexOf("-") + 1, secondaryProductSku.length)
        }

        let label = null;
        let currentCustomProduct = null;
        if (this.labelType === 'gravure_personnalisee') {
          if (this.engravingProduct != null) {
            currentCustomProduct = this.engravingProduct;
          }
        } else if (this.labelType === 'personnalisation_classique') {
          if (this.labelProduct != null) {
            currentCustomProduct = this.labelProduct;
          }
        }

        let availableLabelCount = 0;
        if (currentCustomProduct !== null) {
          label = JSON.parse(JSON.stringify(currentCustomProduct));
          if (this.labelType === 'gravure_personnalisee' && (this.selectedSecondaryProduct.engravingIncludeOnlySku.length > 0 || this.selectedSecondaryProduct.engravingExcludeSku.length > 0)) {
            for (let i = 0; i < label.variants.length; i++) {
              let variant = label.variants[i];
              if (this.selectedSecondaryProduct.engravingIncludeOnlySku.length > 0) {
                for (let j = 0; j < this.selectedSecondaryProduct.engravingIncludeOnlySku.length; j++) {
                  if (!variant.sku.includes(this.selectedSecondaryProduct.engravingIncludeOnlySku[j])) {
                      label.variants[i].available = false;
                  }
                }
              } else {
                for (let j = 0; j < this.selectedSecondaryProduct.engravingExcludeSku.length; j++) {
                  if (variant.sku.includes(this.selectedSecondaryProduct.engravingExcludeSku[j])) {
                      label.variants[i].available = false;
                  }
                }
              }
            }
          }
          let hasSelectedVariant = false;
          let firstAvailableLabelIndex = null;

          for (let i = 0; i < label.variants.length; i++) {
              let variant = label.variants[i];
              if (variant.available) {
                if (firstAvailableLabelIndex == null) {
                  firstAvailableLabelIndex = i;
                }
                if (this.selectedLabel !== null && variant.id == this.selectedLabel.id) {
                    label.variants[i].selected = true;
                    hasSelectedVariant = true;
                    break;
                }
              }
          }
          for (let i = 0; i < label.variants.length; i++) {
            let variant = label.variants[i];
            if (variant.available) {
              availableLabelCount++;
            }
          }

          if (hasSelectedVariant === false && firstAvailableLabelIndex !== null) {
            label.variants[firstAvailableLabelIndex].selected = true;
            this.customizer.resetKey();
            this.selectLabel(currentCustomProduct.variants[firstAvailableLabelIndex].id);
          }
        }

        let sku = this.sku.replace(/-/g, '/');
        if (this.productType === 'CANDLE') {
            sku = sku.slice(0, sku.lastIndexOf("/"))
        }

        let saucerPrice = '';
        let saucer = [];
        if (this.saucerProduct !== undefined && this.saucerProduct !== null) {
          saucer = JSON.parse(JSON.stringify(this.saucerProduct));
          if (this.selectedSaucer != undefined && this.selectedSaucer != null) {
            for (let i = 0; i < saucer.variants.length; i++) {
                let variant = saucer.variants[i];
                if (variant.id == this.selectedSaucer.id) {
                    saucer.variants[i].selected = true;
                    break;
                }
            }
            saucerPrice = " (+" + new Intl.NumberFormat(userLang, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(this.selectedSaucer.price / 100) + ")";
          }
        }

        let fertilizerPrice = '';
        let fertilizer = [];
        if (this.fertilizerProduct !== undefined && this.fertilizerProduct !== null) {
          fertilizer = JSON.parse(JSON.stringify(this.fertilizerProduct));
          if (this.selectedFertilizer != undefined && this.selectedFertilizer != null) {
            for (let i = 0; i < fertilizer.variants.length; i++) {
                let variant = fertilizer.variants[i];
                if (variant.id == this.selectedFertilizer.id) {
                    fertilizer.variants[i].selected = true;
                    break;
                }
            }
            fertilizerPrice = " (+" + new Intl.NumberFormat(userLang, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            }).format(this.selectedFertilizer.price / 100) + ")";
          }
        }

        let upsellOptionsPrice = '';
        let upsellOptions = [];
        let enableUpsell = false;
        if (upsellProducts !== undefined && upsellProducts !== null && upsellProducts.length > 0) {
          upsellOptions = JSON.parse(JSON.stringify(upsellProducts));
          enableUpsell = true;
          let upsellOptionsAmount = 0;

          for (let i = 0; i < upsellOptions.length; i++) {
            for (let j = 0; j < upsellOptions[i].variants.length; j++) {
                let variant = upsellOptions[i].variants[j];

                if (this.selectedUpsellProducts[variant.id] !== undefined && this.selectedUpsellProducts[variant.id] !== null ) {
                  upsellOptions[i].variants[j].selected = true;
                  upsellOptionsAmount += parseFloat(upsellOptions[i].variants[j].price);
                }
            }
          }

          upsellOptionsPrice = " (+" + new Intl.NumberFormat(userLang, {
              style: 'currency',
              currency: currencyCode,
              minimumFractionDigits: 0,
              maximumFractionDigits: 0
          }).format(upsellOptionsAmount) + ")";
        }

        let nbCols = 0;
        if (this.hasNoCustom) {
          nbCols++;
        }
        if (this.hasEngraving && this.selectedSecondaryProduct.hasEngraving) {
          nbCols++;
        }
        if (this.hasLabel && this.selectedSecondaryProduct.hasLabel) {
          nbCols = nbCols+2;
        }

        let enableUpsellSaucer = false;
        let hasEngraving = false;
        let hasLabel = false;

        if (this.selectedSecondaryProduct !== null) {
          enableUpsellSaucer = this.selectedSecondaryProduct.enableUpsellSaucer;
          hasEngraving = this.hasEngraving && this.selectedSecondaryProduct.hasEngraving;
          hasLabel = this.hasLabel && this.selectedSecondaryProduct.hasLabel;
        }

        let data = {
            customizeCheckboxLabel: defaultCustomizeCkeckboxLabel,
            isCustomizable: this.isCustomizable,
            isCustomized: this.isCustomized,
            hasSecondaryProduct: this.hasSecondaryProduct,
            secondaryProduct: secondaryProduct,
            selectedSecondaryProduct: this.selectedSecondaryProduct,
            secondaryProductPrice: secondaryProductPrice,
            secondaryProductTypologies: this.secondaryProductTypologies,
            hasManySecondaryProductTypology: this.hasManySecondaryProductTypology,
            label: label,
            hasManyLabel: availableLabelCount > 1,
            selectedLabel: this.selectedLabel,
            labelType: this.labelType,
            labelPrice: labelPrice,
            engravingPrice: engravingPrice,
            defaultTitle: this.defaultTitle,
            defaultText: this.defaultText,
            sku: sku,
            variantSku: variantSku,
            isLabelsPanelCurrentlyOpen: $('#product_options__labels').hasClass('product_options__popup-mobile--active'),
            isInMulti: this.isInMulti,
            rechargeProduct: this.rechargeProduct,
            customizer_title: this.customizer.getTitle(),
            customizer_subtitle: this.customizer.getText(),
            enableUpsellSaucer: enableUpsellSaucer,
            saucer: saucer,
            selectedSaucer: this.selectedSaucer,
            saucerPrice: saucerPrice,
            hasEngraving: hasEngraving,
            hasLabel: hasLabel,
            hasNoCustom: this.hasNoCustom,
            nbCols: nbCols,
            locales: locales,
            customOnBack: this.secondaryProductType == 'puck',
            variants: this.variants,
            enableFertilizer: this.needFertilizer,
            fertilizer: fertilizer,
            selectedFertilizer: this.selectedFertilizer,
            fertilizerPrice: fertilizerPrice,
            enableUpsell: enableUpsell,
            upsellOptions: upsellOptions,
            upsellOptionsPrice : upsellOptionsPrice,
        };

        this.container.html(bundleTemplate(data));

        initIllustrationsSlider(this.labelType);

        this.initSecondaryProductsFilter();

        $('#thumbnails-slider-upsell').slick({
          slidesToShow: 3,
          slidesToScroll: 3,
          dots:true,
          arrows:false,
        });
    };

    Bundle.prototype.getPrice = function getPrice() {
        let price = this.mainPrice;
        if (this.selectedSecondaryProduct != null) {
            price += this.selectedSecondaryProduct.price;
        }
        if (this.selectedLabel != null && this.isCustomized) {
            price += this.selectedLabel.price;
        }
        if (this.selectedSaucer != null) {
            price += this.selectedSaucer.price;
        }
        if (this.selectedFertilizer != null) {
            price += this.selectedFertilizer.price;
        }

        let keys = Object.keys(this.selectedUpsellProducts);
        for(let i = 0; i < keys.length; i++) {
          price += parseFloat(this.selectedUpsellProducts[keys[i]].price)*100;
        }

        return price;
    }

    Bundle.prototype.setPreview = function setPreview(key) {
        if (this.productType === 'CANDLE' && this.size === 'm') {
            console.warn('Candle M not supported');
            return;
        }

        if (this.selectedSecondaryProduct !== null) {
            const skuParts = this.selectedSecondaryProduct.sku.split('-');
            const url = this.getPreviewUrl(key, true);

            this.previewURL = url;
            const backgroundUrl = this.getBackgroundUrl();
            this.previewBackgroundURL = backgroundUrl;

            this.updatePreview(url, backgroundUrl);
        }
    }

    Bundle.prototype.getBackgroundUrl = function getBackgroundUrl(key, withoutBackground) {
      let sku = this.sku.replace(/-/g, '/');
      if (this.productType === 'CANDLE' || this.productType === 'INFUSER') {
          sku = sku.slice(0, sku.lastIndexOf("/"))
      }

      let secondaryProductSku = this.selectedSecondaryProduct.sku;

      let variantSku = secondaryProductSku.slice(secondaryProductSku.lastIndexOf("-") + 1, secondaryProductSku.length);

      if (this.selectedSecondaryProduct.declinedPreview !== undefined && this.selectedSecondaryProduct.declinedPreview !== null) {
        variantSku += "_" + this.selectedSecondaryProduct.declinedPreview;
      } else if (this.selectedLabel !== null && this.selectedLabel.declinedPreview !== undefined && this.selectedLabel.declinedPreview !== null) {
        variantSku += "_" + this.selectedLabel.declinedPreview;
      }

      return  '//' + AkairosApiHost + '/storage/assets/img/products/' + sku + '/' + variantSku + '.jpg';
    }

    Bundle.prototype.getPreviewUrl = function getPreviewUrl(key, withoutBackground) {
      const skuParts = this.selectedSecondaryProduct.sku.split('-');

      let selectedSecondaryProductSku = skuParts[1];

      let url = '//' + AkairosApiHost + '/v1/label/preview/' + this.sku + '-' + selectedSecondaryProductSku + '/' + key;

      let params = [{"name": "lang", "value": siteLang}];

      if (withoutBackground) {
        params.push({"name": "withoutBackground", "value": true});
      }
      if ((this.selectedSecondaryProduct.declinedPreview !== undefined && this.selectedSecondaryProduct.declinedPreview !== null)) {
        params.push({"name": "declinedBackground", "value": this.selectedSecondaryProduct.declinedPreview});
      } else if (this.selectedLabel !== null && this.selectedLabel.declinedPreview !== undefined && this.selectedLabel.declinedPreview !== null) {
        params.push({"name": "declinedBackground", "value": this.selectedLabel.declinedPreview});
      }

      url += "?";
      for (var i = 0; i < params.length; i++) {
        if (i > 0) {
          url += "&";
        }
        url += params[i].name +"="+ params[i].value;
      }

      return url;
    }

    Bundle.prototype.getDefaultImageUrl = function getDefaultImageUrl() {
      let currentBundleImage = this.images[0].src;
      if (this.hasManyVariants) {
        if (this.variants[this.currentMainVariantIndex].featured_image !== undefined && this.variants[this.currentMainVariantIndex].featured_image !== null) {
          currentBundleImage = this.variants[this.currentMainVariantIndex].featured_image.src;
        }
      }

      if (this.hasSecondaryProduct && this.selectedSecondaryProduct !== null) {
          let imageIndex = this.defaultImageBySecondaryProductSku[this.selectedSecondaryProduct.sku];
          if (imageIndex === undefined) {
            imageIndex = 0;
          }

          if (typeof this.images[imageIndex] == 'string') {
              currentBundleImage = this.images[imageIndex];
          } else {
              currentBundleImage = this.images[imageIndex].src;
          }
      }
      return currentBundleImage;
    }

    Bundle.prototype.updatePreview = function updatePreview(url, backgroundUrl) {
      let isEngraving = false;
      if (this.selectedLabel !== null && this.selectedLabel.isEngraving) {
        isEngraving = true;
      }

      $(':root').trigger("updatePreview", [url, backgroundUrl, isEngraving]);
    }

    Bundle.prototype.isAvailable = function isAvailable() {
        return this.mainAvailable && this.selectedSecondaryProduct != null && this.selectedSecondaryProduct.available;
    }

    Bundle.prototype.change = function change() {
        this.bundlePrice = this.getPrice();
        this.bundleAvailable = this.isAvailable();
        $(":root").trigger("bundleChange", [this]);
    }

    Bundle.prototype.getSummary = function getSummary(index) {
        if (index === undefined ||index === null) {
          index = Math.floor(Math.random() * 10)
        }

        let currentSecondaryProductTitle = "",
            currentCustomizationTitle = "";

        if (this.hasSecondaryProduct && this.selectedSecondaryProduct !== null) {
            currentSecondaryProductTitle = this.selectedSecondaryProduct.option2;
        }

        if (this.isCustomizable) {
            currentCustomizationTitle = "Non Personnalisé";
            if (this.isCustomized) {
                currentCustomizationTitle = this.selectedLabel.option1;
            }
        }

        let currentBundleImage = this.getDefaultImageUrl();
        let previewUrl = currentBundleImage;
        if (this.customized) {
          previewUrl = this.previewURL;
        }

        let summary = '<div>';
        summary += '<img style="opacity:0" src="' + currentBundleImage + '" />';
        summary += '<div style="position: absolute; top:0; left:0;"><img id="slider-preview-background-'+index+'" src="' + this.previewBackgroundURL + '" /></div>';
        summary += '<div style="position: absolute; top:0; left:0;"><img id="slider-preview-'+index+'" src="' + previewUrl + '" /></div>';

        //summary += '<img src="' + currentBundleImage + '" />';
        //summary += '<p>' + currentPotTitle + '<br />' + currentCustomizationTitle + '</p>';
        summary += '</div>';

        return summary;
    }

    Bundle.prototype.addToCart = function addToCart() {
        let productSelect = this.variants[this.currentMainVariantIndex],
            bundleId = productSelect.id + ":" + Date.now() + ":" + Math.floor(Math.random() * (95000 - 10000)) + 10000,
            items = [],
            secondaryProductSku = '',
            currentSecondaryProductTitle = "",
            currentCustomizationTitle = "";

        let mainProperties = {
            '_hasOption': false,
            '_rootBundleId': bundleId,
            '_engraving': this.currentSecondaryProductTypology == 'engraving',
            '_noCustom': this.currentSecondaryProductTypology == 'noCustom' || this.labelType == 'sans_personnalisation'
        };

        let keys = Object.keys(this.selectedUpsellProducts);
        for(let i = 0; i < keys.length; i++) {
          items.push(
              {
                  quantity: 1,
                  id: this.selectedUpsellProducts[keys[i]].id,
              }
          );
        }

        if (this.selectedFertilizer !== null) {
          mainProperties._hasOption = true;

          mainProperties['Engrais'] = this.selectedFertilizer.option1;

          let fProperties = {
              '_bundleId': bundleId,
              '_isUpsell': true,
              '_upsellType': 'engrais',
          };

          items.push(
              {
                  quantity: 1,
                  id: this.selectedFertilizer.id,
                  properties: fProperties
              }
          );
        }

        if (this.selectedSaucer !== null) {
          mainProperties._hasOption = true;

          mainProperties['Soucoupe'] = this.selectedSaucer.option1;

          let saucerProperties = {
              '_bundleId': bundleId,
              '_isUpsell': true,
              '_upsellType': 'soucoupe',
          };

          items.push(
              {
                  quantity: 1,
                  id: this.selectedSaucer.id,
                  properties: saucerProperties
              }
          );
        }

        if (this.hasSecondaryProduct && this.selectedSecondaryProduct !== null) {
            secondaryProductSku = '#' + this.selectedSecondaryProduct.sku;

            mainProperties._currentImgVisual = this.getDefaultImageUrl();

            if (!this.selectedSecondaryProduct.available) {
                console.error("selected secondaryProduct must be avaiable");
                return;
            }

            let optionText = this.selectedSecondaryProduct.option2;
            if (optionText === "" || optionText === null || optionText === undefined) {
              optionText = this.selectedSecondaryProduct.option1;
            }

            currentSecondaryProductTitle = "/" + optionText;

            mainProperties[this.secondaryProductPropertyLabel] = optionText;
            mainProperties._rootSKU = productSelect.sku + secondaryProductSku;
        }

        mainProperties['_tags'] = this.tags;

        if (this.isCustomizable) {
          if (this.labelType != 'sans_personnalisation') {
              // Before check customization and reset if needed
              if (!this.isCustomized) {
                  this.customizer.updateTitle(this.defaultTitle)
                  this.customizer.updateText(this.defaultText);
              }

              this.customizer.compute(false, null, 0, true);

              const customizerProperties = this.customizer.getAsProperties();

              mainProperties = Object.assign(mainProperties, customizerProperties);

              mainProperties[locales.customization] = locales.standardLabel;
              currentCustomizationTitle = "/" + locales.noCustomization;

              if (this.isCustomized) {
                  mainProperties._hasOption = true;
                  mainProperties[locales.customization] = this.selectedLabel.option1;

                  currentCustomizationTitle = "/" + this.selectedLabel.option1;

                  items.push(
                      {
                          quantity: 1,
                          id: this.selectedLabel.id,
                          properties: {
                              '_bundleId': bundleId,
                              '_rootSKU': mainProperties._rootSKU,
                              '_rawTitle': mainProperties._rawTitle,
                              '_rawText': mainProperties._rawText,
                              '_customTitle': mainProperties._customTitle,
                              '_customText': mainProperties._customText,
                              '_customTitleSize': mainProperties._customTitleSize,
                              '_customTopMargin': mainProperties._customTopMargin,
                              '_customUnderTitleMargin': mainProperties._customUnderTitleMargin,
                              '_customUnderSubTitleMargin': mainProperties._customUnderSubTitleMargin,
                          }
                      }
                  );
              }
          } else {
            mainProperties[locales.customization] = locales.noCustom;
          }
        }

        if (this.hasSecondaryProduct && this.selectedSecondaryProduct !== null) {
            mainProperties._hasOption = true;

            let secondaryProductProperties = {
                '_bundleId': bundleId,
            };
            if (items.length > 0) {
                secondaryProductProperties._hasOption = true;
            }

            items.push(
                {
                    quantity: 1,
                    id: this.selectedSecondaryProduct.id,
                    properties: secondaryProductProperties
                }
            );
        }

        mainProperties._newProductName = this.defaultTitle + currentSecondaryProductTitle + currentCustomizationTitle;

        items.push(
            {
                quantity: 1,
                id: productSelect.id,
                properties: mainProperties,
            }
        );

        return items;
    };

    return Bundle;
})();
